import { api } from '~/data/api'
import { IAircraftManufacturer, IResourceScope } from '~/utils/types'

export interface IUseListAssetManufacturers {
  company_id: string
}

export async function listAssetManufacturers(params?: IUseListAssetManufacturers): Promise<IAircraftManufacturer[]> {
  const response = await api().get('aircraft_manufacturer', { params })

  return response.data
}

export interface IUpdateAircraftManufacturerProps {
  aircraft_manufacturer_id?: string
  aircraft_manufacturer: IAircraftManufacturer
}

export async function updateAircraftManufacturer({
  aircraft_manufacturer_id,
  aircraft_manufacturer,
}: IUpdateAircraftManufacturerProps) {
  const response = await api().put(`/aircraft_manufacturer/${aircraft_manufacturer_id}`, {
    ...aircraft_manufacturer,
    name: aircraft_manufacturer.name.toUpperCase(),
  })
  return response.data
}

export async function createAircraftManufacturer(
  aircraft_manufacturer: IAircraftManufacturer,
): Promise<IAircraftManufacturer> {
  const response = await api().post(`/aircraft_manufacturer`, {
    ...aircraft_manufacturer,
    name: aircraft_manufacturer.name.toUpperCase(),
  })
  return response.data
}

export async function deleteAircraftManufacturer(aircraft_manufacturer_id: string) {
  const response = await api().delete(`/aircraft_manufacturer/${aircraft_manufacturer_id}`)
  return response.data
}

export interface IUpdateAssetManufacturerScope extends Omit<IResourceScope, 'asset_manufacturer'> {
  asset_model_id: string
}
export async function updateAssetManufacturerScope(props: IUpdateAssetManufacturerScope) {
  const response = await api().put(`/asset_manufacturer/${props.asset_model_id}/change_scope`, {
    new_scope: props.resource_scope,
    new_owner: props.owner,
  })

  return response
}

export interface IVerifyAssetManufacturerNameProps {
  name: string
  owner?: string
}
export interface IVerifyAssetManufacturerNameResponse {
  name: string
  owner: string
  available: boolean
  existing_id: string | null
}
export async function verifyAssetManufacturerName({
  name,
  owner,
}: IVerifyAssetManufacturerNameProps): Promise<IVerifyAssetManufacturerNameResponse> {
  return await (
    await api().post('/aircraft_manufacturer/verify_name', {
      name,
      owner,
    })
  ).data
}
